import EndSessionModal from './EndSessionModal';

export default EndSessionModal;
